import { Routes, Route } from 'react-router-dom';
import LimerickExperience from './LimerickExperience';
import ExploreEntries from './ExploreEntries';
import GlossaryPage from './GlossaryPage';
import About from './About';
import './index.css';
import { increment } from 'firebase/firestore';


function App() {
  return (
    <Routes>
      <Route path="/" element={<LimerickExperience />} />
      <Route path="/explore" element={<ExploreEntries />} />
      <Route path="/glossary" element={<GlossaryPage />} />
      <Route path="/about" element={<About />} />
    </Routes>    
  );
}

export default App;